import { createContext, type Dispatch } from 'react';

import { type Price } from '../../shared/price';

type PriceContextValue = {
    price: Price;
    setAmount: Dispatch<number>;
    setMultiplier: Dispatch<number>;
};

const PriceContext = createContext<PriceContextValue | undefined>(undefined);

export { PriceContext };
export type { PriceContextValue };
